import StatusDot from "./StatusDot";
import NavRow from "./NavRow";
import AccountMenu from "./AccountMenu";
import { visibleNavItems } from "./nav";
import { useAuth } from "../hooks/useAuth";
import type { AppStatus } from "../hooks/useAppStatus";

/**
 * The desktop navigation: always on screen, never collapsed.
 *
 * A burger belongs on a phone, where 224px of a 390px screen is more than half
 * the width. On a 1440px laptop the same column costs 15% and buys every
 * section in one click, so there is nothing to hide and nothing to toggle.
 *
 * Below `md` this is gone entirely and the burger in the top bar takes over.
 */
export default function SideNav({ status }: { status: AppStatus }) {
  const { user } = useAuth();
  const items = visibleNavItems(user?.is_owner ?? false);

  return (
    <aside className="jv-chrome hidden w-56 shrink-0 flex-col border-r border-line md:flex">
      <div className="flex items-center gap-2.5 px-5 py-4">
        <span
          aria-hidden="true"
          className="grid size-8 shrink-0 place-items-center rounded-control bg-accent/15 font-mono text-title font-semibold text-accent"
        >
          J
        </span>
        <span className="text-sm font-semibold tracking-tight">Jarvis</span>
      </div>

      <nav aria-label="Розділи" className="flex-1 overflow-y-auto p-2">
        <ul>
          {items.map((item) => (
            <li key={item.to}>
              <NavRow item={item} />
            </li>
          ))}
        </ul>
      </nav>

      <div className="flex items-center justify-between gap-2 border-t border-line px-4 py-3">
        <StatusDot
          tone={status.tone}
          pulse={status.tone === "ok"}
          label={status.statusText}
          title={status.statusTitle || status.statusText}
          className="min-w-0"
        />
        <AccountMenu />
      </div>
    </aside>
  );
}
